'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chooseEmailCapturePromptText = undefined;

var _reselect = require('reselect');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _getShouldShowOfficeHoursEmailCaptureMessage = require('./getShouldShowOfficeHoursEmailCaptureMessage');

var _getShouldShowOfficeHoursEmailCaptureMessage2 = _interopRequireDefault(_getShouldShowOfficeHoursEmailCaptureMessage);

var _getAskForEmailMessage = require('../../selectors/widgetDataSelectors/getAskForEmailMessage');

var _widgetIsInAwayMode = require('../../availability/selectors/widgetIsInAwayMode');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chooseEmailCapturePromptText = exports.chooseEmailCapturePromptText = (0, _reselect.createSelector)([_widgetIsInAwayMode.widgetIsInAwayMode, _getShouldShowOfficeHoursEmailCaptureMessage2.default, _getAskForEmailMessage.getAskForEmailMessage], function (widgetIsAway, shouldShowOfficeHoursEmailCaptureMessage, askForEmailMessage) {
  if (widgetIsAway) {
    return _I18n2.default.text('conversationsUI.emailCapture.defaultAwayEmailCaptureMessage');
  }

  if (shouldShowOfficeHoursEmailCaptureMessage) {
    return _I18n2.default.text('conversationsUI.emailCapture.outsideOfficeHoursMessage');
  }

  return askForEmailMessage;
});


//////////////////
// WEBPACK FOOTER
// ./js/email-capture/selectors/chooseEmailCapturePromptText.js
// module id = 384
// module chunks = 2 3